import { render } from "./CustomerTable.vue?vue&type=template&id=81798f34&scoped=true"
import script from "./CustomerTable.vue?vue&type=script&lang=js"
export * from "./CustomerTable.vue?vue&type=script&lang=js"

import "./CustomerTable.vue?vue&type=style&index=0&id=81798f34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81798f34"]])

export default __exports__